import { useBreakpoint } from "@/ui/hooks";

export function useIsMobileView() {
  const currentBreakpoint = useBreakpoint({ ssr: false }) as Breakpoint;
  return currentBreakpoint === "base";
}
